var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSostenible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F7F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 17C24 17 17 23.4333 17 32C17 35.5333 18.2333 38.7833 20.2833 41.35L17 44.65L19.35 47L22.6333 43.7167C25.2167 45.7667 28.4667 47 32 47C35.8333 47 39.6833 45.5333 42.6 42.6C45.5333 39.6833 47 35.8333 47 32V17H32ZM43.6667 32C43.6667 35.1167 42.45 38.05 40.25 40.25C38.05 42.45 35.1167 43.6667 32 43.6667C25.5667 43.6667 20.3333 38.4333 20.3333 32C20.3333 28.8333 21.5667 25.8667 23.8333 23.6833C26.0333 21.5167 28.9333 20.3333 32 20.3333H43.6667V32Z",
    fill: "#043873"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1 33.05L32.85 33.7167L28.7833 39.2667C28.6 39.5333 28.6167 39.9 28.85 40.1333C29.1 40.3833 29.5167 40.4 29.7833 40.15L38.3833 32.4333C38.9333 31.9333 38.6333 31.0167 37.8833 30.95L31.1333 30.2833L35.2 24.7333C35.3833 24.4667 35.3667 24.1 35.1333 23.8667C34.8833 23.6167 34.4667 23.6 34.2 23.85L25.6 31.5667C25.0667 32.0667 25.3667 32.9833 26.1 33.05Z",
    fill: "#043873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSostenible);
export default __webpack_public_path__ + "static/media/icon-sostenible.5e34e0f5d3213372e4b5729ea01850a0.svg";
export { ForwardRef as ReactComponent };